import image1 from '../../assets/images/Rita.jpg';
import image2 from '../../assets/images/MAXIMINA-nietos.jpg';
import image3 from '../../assets/images/4mujeres.jpg';
import image4 from '../../assets/images/Iñiguez-familia.jpg';
import image5 from '../../assets/images/Luis.jpg';

export const cards = [
    {
        header: "Rita",
        image: image1,
        text: `- Mi legado es mi mensaje -`,
    },
    {
        header: "Maximina",
        image: image2,
        text: `- Aroma a hogar -`,
    },

    {
        header: "Lucy",
        image: image3,
        text: `- Una mujer de Pilar -`,
    },
    {
        header: "Lily",
        image: image4,
        text: `- Herencia de un estilo -`,
    },
    {
        header: "Luis",
        image: image5,
        text: `- Cosecha de una vida plena -`,
    },
];